import React from 'react';
import { useTranslation } from '../../i18n/useTranslation';
import './Gallery.css';

const galleryImages = [
  { src: '/images/gallery/repair-zone.jpg', key: 0 },
  { src: '/images/gallery/diagnostics.jpg', key: 1 },
  { src: '/images/gallery/lifts.jpg', key: 2 },
  { src: '/images/gallery/tires.jpg', key: 3 },
  { src: '/images/gallery/Waitingarea.jpg', key: 4 },
  { src: '/images/gallery/tools.jpg', key: 5 },
];

const Gallery = () => {
  const { t } = useTranslation();
  const raw = t('gallery.items');
  const items = Array.isArray(raw) ? raw : [];

  return (
    <section className="section">
      <div className="container">
        <h2 className="section-title" style={{ textAlign: 'center' }}>
          {t('gallery.title')}
        </h2>
        <p className="section-subtitle" style={{ textAlign: 'center', margin: '0 auto 48px' }}>
          {t('gallery.subtitle')}
        </p>
        <div className="gallery__grid">
          {items.map((item, index) => {
            const img = galleryImages[index];
            return (
              <div key={index} className="gallery__item">
                {img?.src ? (
                  <div className="gallery__image-wrapper">
                    <img
                      src={img.src}
                      alt={item.title || ''}
                      className="gallery__image"
                      onError={(e) => {
                        e.target.parentElement.innerHTML = `
                          <div class="gallery__placeholder">
                            <span class="gallery__emoji">${item.emoji || '🔧'}</span>
                            <span class="gallery__label">${item.title || ''}</span>
                          </div>
                        `;
                      }}
                    />
                    <div className="gallery__image-overlay">
                      <span className="gallery__label">{item.title || ''}</span>
                    </div>
                  </div>
                ) : (
                  <div className="gallery__placeholder">
                    <span className="gallery__emoji">{item.emoji || '🔧'}</span>
                    <span className="gallery__label">{item.title || ''}</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Gallery;